import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const OPTS = Array.from({ length: 32 }, (_, i) => (i + 1) * 15);
const fmt = (m) => `${Math.floor(m / 60) ? `${Math.floor(m / 60)}h ` : ""}${m % 60 ? `${m % 60}m` : ""}`.trim();

export function ApproveBriefDialog({ step, mainId, takeOver, onClose }) {
  const [mins, setMins] = useState("");
  const [busy, setBusy] = useState(false);
  const [logged, setLogged] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      if (takeOver && !logged) await api.put(`/console/tasks/${step.id}`, { assignee_id: takeOver });
      if (!logged) { await api.post(`/console/tasks/${step.id}/time`, { minutes: Number(mins) }); setLogged(true); }
      await api.put(`/console/tasks/${step.id}`, { status: "Completed" });
      toast.success("Brief approved. Drafting can start.");
      window.location.assign(`/console?task=${mainId}`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="brief-approve-dialog">
        <DialogHeader>
          <DialogTitle>Approve the brief</DialogTitle>
          <DialogDescription>Log the time you spent reviewing the brief and strategy. This completes "{step.title}" and moves the flow to drafting.{takeOver ? " This brief is assigned to someone else, so approving it moves the task and the logged time to you." : ""}</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <label className="text-xs text-[#595D62]">Time spent</label>
          <Select value={mins} onValueChange={setMins} disabled={logged}>
            <SelectTrigger data-testid="brief-approve-time"><SelectValue placeholder="Choose time spent" /></SelectTrigger>
            <SelectContent className="max-h-64">{OPTS.map((m) => <SelectItem key={m} value={String(m)} data-testid={`brief-time-${m}`}>{fmt(m)}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={onClose} disabled={busy} data-testid="brief-approve-cancel">Cancel</Button>
          <Button data-testid="brief-approve-confirm" disabled={!mins || busy} onClick={go} className="rounded-full bg-[#06060C] hover:bg-[#1c1c24] text-white">
            {busy && <Loader2 className="h-4 w-4 mr-1.5 animate-spin" />} Approve & complete
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
